import get from 'lodash.get';

import isObject from './isObject.js';

/**
 * Handle a debug log
 * @param {string} action Name of the debug point
 * @param {object} app Custom debug properties
 * @param {string} app.code Custom debug code for filtering
 * @param {string} app.origin Custom origin label to find out the logpoints
 * @param {object} [app.detail] Any more details
 */
export default (action, app) => {
	if (typeof action !== 'string') {
		throw new Error('Invalid method arguments to appDebug, "action" should be a string with name of the action');
	} else if (!isObject(app) || typeof app.code !== 'string' || typeof app.origin !== 'string') {
		throw new Error('Invalid method arguments to appDebug, "app" should be an Object with code and origin');
	} else if (get(window, 'avastGlobals.cart.initialState.order.isDebug')) {
		console.info(action, app); // logger utility is not used to prevent circullar dependency issue
	}
};
